<template>
  <div class="pm-dialog-caution-note">
    <div class="flex justify-center vs-row outer-area">
      <div class="vs-col candidate-list" v-for="(master,index) in cautionNoteList" :key="index">
        <vs-chip 
          class="caution-item"
          :color="'#' + master.color.color_hex "
        >
          {{ master.name }}
        </vs-chip>
      </div>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("portMasterDestinationWork");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
  },
  data() {
    return {
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    cautionNoteList() {
      const cautionNoteList = this.valueMap && this.valueMap.value ? this.valueMap.value : [];
      return cautionNoteList.map(x => {return {color:x.tag.color, name:x.tag.name}});
    },
  },
  methods: {
    initData() {
    },
    onSubmit() {
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey] = this.selectedId;
      this.$emit('updateValue',this.taskId, updateKeyValueMap);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";

.pm-dialog-caution-note {
  .outer-area {
    padding: 1rem;
  }
  .candidate-list {
    margin: 0.2rem;
  }
  .caution-item {
    border-radius: 5px;
    height: 3rem;
    width: 100%;
    margin: 0 0.2rem;
  }
  .save-button {
    margin: 0 1rem;
    width: 30%
  }
}
</style>

